import { getStore } from 'shared/stash';

export const SET_AGENT_CONTEXT = 'SET_AGENT_CONTEXT';
export const FORGET_AGENT_CONTEXT = 'FORGET_AGENT_CONTEXT';

export function setAgentContext(contextType, contextId) {
  getStore().dispatch({
    type: SET_AGENT_CONTEXT,
    contextType,
    contextId,
  });
}
